import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MarketPageService } from '../services/market-page.service';
import { Farm, FarmLocations } from '../../models/types';
import { FormsModule } from '@angular/forms';
import { FarmListComponent } from '../components/farm-list/farm-list.component';
import { ProfilePageService } from '../services/profile-page.service';
import { MapComponent } from '../components/map/map.component';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MapService } from '../services/map.service';


@Component({
  selector: 'app-all-farms-page',
  standalone: true,
  imports: [CommonModule, FormsModule, FarmListComponent, MapComponent, FontAwesomeModule],
  templateUrl: './all-farms-page.component.html',
  styleUrl: './all-farms-page.component.scss'
})
export class AllFarmsPageComponent {
  allFarms: Farm[] = [];
  allFarmsShow: Farm[] = [];
  farmCount: number = 0;
  message = ''
  isOnMarketPage = true;
  filteredFarms: Farm[] = [];
  farmNameFilter: string = '';
  farmLocations: FarmLocations[] = [];

  faLocationDot = faLocationDot;

  constructor(
    private router: Router,
    private marketPageService: MarketPageService,
    private profilePageService: ProfilePageService,
    private mapService: MapService) {}

  ngOnInit() {
    this.fetchAllFarms();
    this.fetchAllFarmLocations();
  }

  fetchAllFarms() {
    this.marketPageService.getAllFarms().subscribe((response) => {
      this.allFarms = response.body!.farms;
      this.allFarmsShow = this.allFarms;
      this.farmCount = response.body!.count;
      console.log('Farms fetched:', this.allFarms);
    });
  }

  fetchAllFarmLocations() {
    this.mapService.GetFarmLocations().subscribe((response) => {
      this.farmLocations = this.transformResponseToFarmLocations(response);
      console.log('Farm Locations in market-page:', this.farmLocations);
    });
  }

  transformResponseToFarmLocations(response: any): FarmLocations[] {
    const locationsObj = response.body.locations;
    const farmLocationsArray: FarmLocations[] = [];

    for (const key in locationsObj) {
      if (locationsObj.hasOwnProperty(key)) {
        farmLocationsArray.push(locationsObj[key]);
      }
    }

    return farmLocationsArray;
  }

  applyFilters(): void {
    this.allFarmsShow = this.allFarms;
    console.log('Applying filters...');
    console.log('Farm Name Filter:', this.farmNameFilter);

    this.filteredFarms = this.allFarmsShow.filter((farm: Farm) => {
      // Filter by farm name
      if (this.farmNameFilter && !farm.name.toLowerCase().includes(this.farmNameFilter.toLowerCase())) {
        console.log(`Filtered out ${farm.name} due to farm name filter`);
        return false;
      }

      // Farm passed the name filter
      console.log(`Kept ${farm.name}`);
      return true;
    });

    console.log('Filtered Farms:', this.filteredFarms);
    this.allFarmsShow = this.filteredFarms;
  }

  clearFilters(): void {
    this.farmNameFilter = '';  // Clear the farm name filter
    this.filteredFarms = this.allFarms;  // Reset the filtered farms to show all farms
    console.log('Filters cleared, showing all farms.');
  }
  

}
